import { Badge } from "@/screens/play-screen/Sections/TodayLiveGames/Badge"

interface LiveBadgeProps {
  isPractice?: boolean
}

export const LiveBadge: React.FC<LiveBadgeProps> = ({ isPractice = false }) => {
  const label = isPractice ? ' ' : 'LIVE';
  return (
    <Badge label={label} />
  )
}
